
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import InterviewLoading from "@/components/candidate/interviews/InterviewLoading.vue";
import AppAssessmentTermConditions from "@/components/AppAssessmentTermConditions.vue";
import AppAiAssessmentRoot from "@/components/candidate/app_assessments/ai_assessment/AppAiAssessmentRoot.vue";
import { ApplicantAssessment } from "@/store/modules/recruiter/interfaces";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import { APPLICANT_ASSESSMENTS } from "@/store/modules/recruiter/constants";
import { FETCH_APPLICANT_ASSESSMENTS } from "@/store/modules/recruiter/constants";
import domtoimage from "dom-to-image-more";
import { get_random_number_between, wait_until } from "@/utils/global";

export default Vue.extend({
  name: "InceptionAiAssessmentIndex",
  components: {
    InterviewLoading,
    AppAssessmentTermConditions,
    AppAiAssessmentRoot
  },
  data() {
    return {
      term_condition_accepted: false, // Set to true if terms already accepted
      data_loading: false,
      local_assessment_completed: false,
      data_error: "",
      assessment_cancelled: false,
      assessment_completed: false,
      loading: false,
      assessments: [] as ApplicantAssessment[],
      screen_shots: [] as string[]
    };
  },
  computed: {
    ...mapGetters("auth", {
      user: GET_USER_DETAILS
    }),
    ...mapGetters("recruiter", {
      applicantAssessments: APPLICANT_ASSESSMENTS
    })
  },
  async created() {
    await this.init();
  },
  async mounted() {
    await this.init();
  },
  methods: {
    ...mapActions("recruiter", {
      fetchApplicantAssessments: FETCH_APPLICANT_ASSESSMENTS
    }),
    async init(this: any) {
      if (this.term_condition_accepted) {
        // We're viewing the assessment list
        await this.loadAssessments();
        return;
      }
    },
    async loadAssessments(this: any) {
      this.loading = true;
      try {
        const applicantId = this.user?.id;
        if (!applicantId) {
          throw new Error("User ID not found");
        }

        const success = await this.fetchApplicantAssessments(
          applicantId.toString()
        );
        if (success) {
          this.assessments = this.applicantAssessments;
        }
      } catch (error) {
        console.error("Failed to load assessments:", error);
        this.data_error = this.$t("assessment.load-error").toString();
        this.$store.commit("ROOT_ERROR", error, { root: true });
      } finally {
        this.loading = false;
      }
    },
    async process_term_condition(val: boolean) {
      if (!val) {
        console.log("Before push");
        this.local_assessment_completed = true;
        await this.$router.push("/candidate/ai-assessments");
      } else {
        this.term_condition_accepted = true;
        console.log("Before init");
        await this.init();
        // Screenshot capture
        // eslint-disable-next-line no-constant-condition
        while (true) {
          if (
            this.assessment_cancelled ||
            this.assessment_completed ||
            this.local_assessment_completed ||
            !this.term_condition_accepted
          )
            break;
          const randomNumber = get_random_number_between(8, 12);
          await wait_until(randomNumber * 1000);
          const img = await domtoimage.toPng(document.body);
          this.screen_shots.push(img);
        }
      }
    },
    getDifficultyColor(difficulty: string): string {
      switch (difficulty.toLowerCase()) {
        case "beginner":
        case "easy":
          return "success";
        case "intermediate":
        case "medium":
          return "warning";
        case "advanced":
        case "hard":
          return "error";
        default:
          return "grey";
      }
    },
    formatDate(dateString: string): string {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    startAssessment(this: any, assessment: ApplicantAssessment) {
      this.$router.push({
        name: "candidate-ai-assessment",
        params: { id: assessment.assessment.id.toString() }
      });
    },
    goToDashboard(this: any) {
      this.$router.push("/candidate/dashboard");
    }
  }
});
